module.exports = __webpack_public_path__ + "static/img/empty-state-cart.67e61a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-state-cart.svg
// module id = uV5t
// module chunks = 0